import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClientePacoteRoutingModule } from './central-cliente-pacote-routing.module';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    CentralClientePacoteRoutingModule,
    TableModule,
    DividerModule,
    ButtonModule,
    MessagesModule,
    InputTextModule
  ]
})
export class CentralClientePacoteModule { }
